var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4339_14312)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6211 13.6854L11.9426 10.0067C12.5676 9.01163 12.9303 7.83557 12.9303 6.57343C12.9303 3.00269 10.0356 0.108398 6.46503 0.108398C2.89442 0.108398 0 3.00269 0 6.57343C0 10.1443 2.89429 13.0383 6.46503 13.0383C7.83856 13.0383 9.1108 12.6089 10.1577 11.8792L13.7924 15.5142C14.045 15.7665 14.3761 15.8922 14.7068 15.8922C15.0378 15.8922 15.3685 15.7665 15.6215 15.5142C16.1262 15.009 16.1262 14.1905 15.6211 13.6854ZM6.46503 10.9438C4.05162 10.9438 2.09498 8.98725 2.09498 6.5737C2.09498 4.16016 4.05162 2.20351 6.46503 2.20351C8.87858 2.20351 10.8351 4.16016 10.8351 6.5737C10.8351 8.98725 8.87858 10.9438 6.46503 10.9438Z",
    fill: "#116E5F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4339_14312"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.2549953697cb25710f93ae49554aaa83.svg";
export { ForwardRef as ReactComponent };